// @flow

import * as React from 'react';
import Box from 'sail/Box';
import {Heading} from 'sail/Text';
import './PaymentsMoreGuides.scss';

type PaymentsMoreGuidesProps = {|
  children: React.Node,
|};

export const PaymentsMoreGuides = ({children}: PaymentsMoreGuidesProps) => {
  return (
    <Box
      flex={{justifyContent: 'space-between'}}
      className="PaymentsMoreGuides"
      margin={{top: 16}}
    >
      {children}
    </Box>
  );
};

type PaymentsMoreGuidesCategoryProps = {|
  title: string,
  children: React.Node,
|};

export const PaymentsMoreGuidesCategory = ({
  title,
  children,
}: PaymentsMoreGuidesCategoryProps) => {
  return (
    <Box className="PaymentsMoreGuides-category">
      <Heading>{title}</Heading>
      {children}
    </Box>
  );
};
